var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { convertToCSSValue, getMaximumHeight, getMaximumWidth, getMinimumHeight, getMinimumWidth } from '../../helpers/styles';
import ChildItemWidget from '../ChildItemWidget';
import Panel from '../Panel';
var StyledGridLayout = styled(Panel).attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: ", ";\n  /* margin-top: ", "; */\n  margin-right: ", ";\n  margin-bottom: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  background: ", ";\n  padding: ", ";\n  display: ", ";\n  height: ", ";\n  width: ", ";\n  max-height: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  max-width: ", ";\n"], ["\n  margin-left: ",
    ";\n  /* margin-top: ", "; */\n  margin-right: ",
    ";\n  margin-bottom: ",
    ";\n  align-items: ", ";\n  justify-content: ", ";\n  background: ", ";\n  padding: ", ";\n  display: ", ";\n  height: ", ";\n  width: ", ";\n  max-height: ",
    ";\n  min-height: ",
    ";\n  min-width: ",
    ";\n  max-width: ",
    ";\n"])), function (_a) {
    var leftMargin = _a.attributes.leftMargin;
    return convertToCSSValue(leftMargin);
}, function (_a) {
    var topMargin = _a.attributes.topMargin;
    return topMargin + "px";
}, function (_a) {
    var rightMargin = _a.attributes.rightMargin;
    return convertToCSSValue(rightMargin);
}, function (_a) {
    var bottomMargin = _a.attributes.bottomMargin;
    return convertToCSSValue(bottomMargin);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes === null || attributes === void 0 ? void 0 : attributes.alignItems;
}, function (_a) {
    var attributes = _a.attributes;
    return attributes === null || attributes === void 0 ? void 0 : attributes.justifyContent;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.background;
}, function (_a) {
    var spacing = _a.attributes.spacing;
    return spacing + "px";
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.width;
}, function (_a) {
    var maximumSize = _a.attributes.maximumSize;
    return getMaximumHeight(maximumSize);
}, function (_a) {
    var minimumSize = _a.attributes.minimumSize;
    return getMinimumHeight(minimumSize);
}, function (_a) {
    var minimumSize = _a.attributes.minimumSize;
    return getMinimumWidth(minimumSize);
}, function (_a) {
    var maximumSize = _a.attributes.maximumSize;
    return getMaximumWidth(maximumSize);
});
var GridLayout = function (props) {
    var identifier = props.identifier, restProps = __rest(props, ["identifier"]);
    return (React.createElement(StyledGridLayout, __assign({ id: identifier }, restProps),
        React.createElement(ChildItemWidget, __assign({}, restProps))));
};
export default GridLayout;
var templateObject_1;
//# sourceMappingURL=index.js.map